import React from "react";
import { Button } from "react-bootstrap";
import FiChevronUp from "../../../../constants/icons/Fi/FiChevronUp";
import FiChevronDown from "../../../../constants/icons/Fi/FiChevronDown";
import MdCheckBox from "../../../../constants/icons/Md/MdCheckBox";
import MdCheckBoxOutlineBlank from "../../../../constants/icons/Md/MdCheckBoxOutlineBlank";
import withSubscriptionCheckButton from "../../../../components/Common/withSubscriptionCheckButton";

const ViewButton = withSubscriptionCheckButton(
  Button,
  "Practice",
  true,
  false,
  "student-practice-view-attempts my-0"
);

const Sidebar = ({
  sectionsList,
  selectedSections,
  setSelectedSections,
  selectedTopic,
  setSelectedTopic,
  selectedMobileTopic,
  setSelectedMobileTopic,
  scrollToTopic,
  roleOfTheUser,
  classroomId,
  activeTab,
  hasValidSubscription,
  onViewAllAttempts,
  isLoading,
  classroomLoader,
  isMobileView,
}) => {
  return (
    <div
      className={`${
        isMobileView ? "d-block d-lg-none" : "d-none d-lg-block"
      } col-4 scrollbarWidth`}
      style={{
        position: "sticky",
        top: "67px",
        zIndex: 5,
        overflowY: "auto",
        maxHeight: "600px",
        marginTop: "15px",
        paddingLeft: "0px",
      }}
    >
      {sectionsList?.length ? (
        <div className="d-flex justify-content-start align-items-center my-2">
          {roleOfTheUser === "Student" ? (
            <ViewButton
              onClick={onViewAllAttempts}
              classRoomId={classroomId}
              requiredFeature="Practice"
              hasValidSubscription={hasValidSubscription}
              subjects={[activeTab]}
              index={0}
            >
              View Attempts
            </ViewButton>
          ) : (
            <Button
              className="student-practice-view-attempts my-0"
              onClick={onViewAllAttempts}
            >
              View Attempts
            </Button>
          )}
        </div>
      ) : (
        ""
      )}
      <div className="card p-0">
        {!isLoading && !classroomLoader && sectionsList?.length ? (
          sectionsList.map((section, index) => {
            const isSelected = selectedSections.some(
              (selec) => selec === section?._id
            );
            return (
              <div key={index}>
                <div
                  className="d-flex justify-content-between"
                  style={{
                    background: isSelected ? "#F5F7FA" : "white",
                    border: isSelected ? "1px solid #E9EAF0" : "",
                    padding: "20px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "22px",
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                      color: isSelected ? "#564FFD" : "#1D2026",
                    }}
                    onClick={() => {
                      if (isSelected) {
                        setSelectedSections(
                          selectedSections.filter(
                            (selec) => selec !== section?._id
                          )
                        );
                      } else {
                        setSelectedSections([
                          ...selectedSections,
                          section?._id,
                        ]);
                      }
                    }}
                  >
                    {isSelected ? (
                      <FiChevronUp
                        size={20}
                        style={{ marginRight: "8px", cursor: "pointer" }}
                      />
                    ) : (
                      <FiChevronDown
                        size={20}
                        style={{ marginRight: "8px", cursor: "pointer" }}
                      />
                    )}{" "}
                    {section?.name}
                  </div>
                </div>
                {isSelected ? (
                  section?.topics?.length ? (
                    <div className="py-2">
                      {section?.topics?.map((topic, index) => {
                        const isTopicSelected = isMobileView
                          ? selectedMobileTopic.some(
                              (selec) => selec === topic?._id
                            )
                          : topic?._id === selectedTopic;
                        return (
                          <div
                            className="d-flex align-items-center concept-videos-topic"
                            style={{
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: 400,
                              lineHeight: "22px",
                              letterSpacing: "-0.01em",
                              textAlign: "left",
                              color: isTopicSelected ? "#1D2026" : "#4E5566",
                              backgroundColor: isTopicSelected ? "#EBEBFF" : "",
                              padding: "12px 20px 12px 20px",
                            }}
                            key={`top-${index}`}
                            onClick={() => {
                              if (isMobileView) {
                                if (isTopicSelected) {
                                  setSelectedMobileTopic(
                                    selectedMobileTopic.filter(
                                      (selec) => selec !== topic?._id
                                    )
                                  );
                                } else {
                                  setSelectedMobileTopic([
                                    ...selectedMobileTopic,
                                    topic?._id,
                                  ]);
                                }
                              } else {
                                scrollToTopic(topic?._id);
                                setSelectedTopic(topic?._id);
                              }
                            }}
                          >
                            {isTopicSelected ? (
                              <MdCheckBox
                                size={20}
                                color="#564FFD"
                                style={{ marginRight: "12px" }}
                              />
                            ) : (
                              <MdCheckBoxOutlineBlank
                                size={20}
                                color="#CED1D9"
                                style={{ marginRight: "12px" }}
                              />
                            )}
                            {`${index + 1}. ${topic?.name}`}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="p-4">
                      No topics present in this section.
                    </div>
                  )
                ) : (
                  ""
                )}
                <div style={{ border: "1px solid #E9EAF0" }} />
              </div>
            );
          })
        ) : !isLoading && !classroomLoader && sectionsList?.length === 0 ? (
          <div className="p-4">No sections present in this subject.</div>
        ) : null}
      </div>
    </div>
  );
};

export default Sidebar;
